package fr.xibalba.generateurClassesLycee.eleves

enum class Specialite(val code: String) {
    LLCE("AGL 8 O"),
    AMC("AMC 8 O"),
    HGGSP("HGGSP O"),
    HLP("HLPHI O"),
    MATHS("MATHS O"),
    NSI("NSINF O"),
    PC("PH-CH O"),
    SES("SES O"),
    SIPH("SISPH O"),
    SI("SC-IG O"),
    SVT("SVT O");

    companion object {
        fun fromCode(code: String): Specialite? {
            return entries.find { it.code == code }
        }
    }
}

enum class Option(val code: String) {
    MATHEX("MATEX F"),
    MATHCO("MATCO F"),
    DGEMC("DGEMC F");

    companion object {
        fun fromCode(code: String): Option? {
            return entries.find { it.code == code }
        }
    }
}

enum class Section(val code: String) {
    EPS("EPS F"),
    EURO("AGL9 F"),
    ART("A-PLA F");

    companion object {
        fun fromCode(code: String): Section? {
            return entries.find { it.code == code }
        }
    }
}

enum class Langue(val code: String) {
    ALLEMAND("ALL2 O"),
    ESPAGNOL("ESP2 O"),
    ITALIEN("ITA2 O");

    companion object {
        fun fromCode(code: String): Langue? {
            return entries.find { it.code == code }
        }
    }
}

enum class TypeSTI2D(val code: String) {
    ARCHITECTURE_CONSTRUCTION("TSTI2D ARCHITECTURE CONSTRUCTION"),
    ENERGIES_ENVIRONNEMENT("TSTI2D ENERGIES  ET ENVIRONNEMENT"),
    INNOVATION_TECHNOLOGIQUE("TSTI2D INNOV.TECHNO.  ECO CONCEPT."),
    SYSTEMES_INFORMATIQUES_NUMERIQUES("TSTI2D SYSTÈME INFO. ET NUMERIQUE");

    companion object {
        fun fromCode(code: String): TypeSTI2D? {
            return entries.find { it.code == code }
        }
    }
}